import { Component, OnDestroy } from '@angular/core';

@Component({
    selector: 'app-cart-offcanvas-preview',
    templateUrl: './cart-offcanvas-preview.component.html',
    standalone: false
})
export class CartOffcanvasPreviewComponent implements OnDestroy {

  public ngOnDestroy(): void {
    document.getElementsByTagName('body')[0].style.removeProperty("overflow"); // temp fix for "cleaning up the javascript offcanvas problem"
  }

}
